import { AlignSetting } from '@webapp/common/lib/ui';

export interface SurveyAddonView {
    buttonBlockPosition: AlignSetting;
    gap: number;
    lineHeight: number;
    paddingBottom: number;
    paddingLeft: number;
    paddingRight: number;
    paddingTop: number;
    questionBlockPosition: AlignSetting;
}

export const initialSurveyAddonView: Readonly<SurveyAddonView> = {
    buttonBlockPosition: AlignSetting.LEFT,
    gap: 3,
    lineHeight: 2,
    paddingBottom: 2,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 2,
    questionBlockPosition: AlignSetting.LEFT,
};
